document.addEventListener('DOMContentLoaded', () => {
    const variantItemsWrapper = document.querySelectorAll('.variants-items__selector .variant-item')
    const drawer = document.querySelector('.drawer');

    console.log('custom')

    // Logic collapse footer labels
    if(document.body.clientWidth <= 1024){
        const footer = document.querySelector('footer');
        const blocksFooter = footer.querySelectorAll('.menu-label');
        blocksFooter.forEach(block => {
            const blocksFooterContent = block.parentNode;
            block.addEventListener('click' , (e) => {
                e.preventDefault();
                blocksFooter.forEach(element => element.parentNode.classList.remove('active'));
                blocksFooterContent.classList.add('active');
            })
        });
    }

    let span;
    let overlayWrapper;
    variantItemsWrapper.forEach(element => {
        const label = element.querySelector('label');
        label.addEventListener('click' , (e) => {
            overlayWrapper = e.currentTarget.querySelector('.loader-wrapper');
            span = e.currentTarget.querySelector('span');
            if(!overlayWrapper.classList.contains('actitve')) overlayWrapper.classList.add('active');
            if(span.classList.contains('hidden')) span.classList.remove('hidden');
            if(drawer.classList.contains('active')) {
                span.classList.add('hidden')
                overlayWrapper.classList.remove('active')
            }
        })
    })

    window.addEventListener('SCE:add', (e) =>{
        console.log('agrego')
        span.classList.add('hidden')
        overlayWrapper.classList.remove('active')
    })


  // Fix open filter labels (mobile)
 const btnFilter = document.querySelector('.mobile-facets__open-wrapper');
 const filters = document.querySelectorAll('#FacetsWrapperMobile details');
 if(btnFilter) {
  btnFilter.addEventListener('click', () => {
    filters.forEach(filter => {
        if(!filter.getAttribute('open')) filter.setAttribute('open', '')
    });
  });
}

// Product page - Show BIS widget if selected size is out of stock
let productPage = document.querySelector('.variant-Size');
console.log('productPage', productPage);
if(productPage){
    console.log(productPage);
    setTimeout(() => {
        if(document.querySelector('.variant-Size input[name="Size"]:checked')){
            document.querySelector('#sealapps-bis-widget').style.cssText = 'display:flex !important;';
        }   
        let inputSizes = document.querySelectorAll('.variant-Size input[name="Size"]');
        inputSizes.forEach(input => {
            input.addEventListener('click', (e) => {
                if(!e.currentTarget.dataset.stock || e.currentTarget.dataset.stock === 'false'){
                    console.log('mostrar widget');
                    document.querySelector('#sealapps-bis-widget').style.cssText = 'display:flex !important;';
                } else {
                    console.log('ocultar widget');
                    document.querySelector('#sealapps-bis-widget').style.cssText = 'display:none !important;';
                }
            });
        });
    }, 2000);
}


})

document.addEventListener('DOMContentLoaded', () => {

    // comprobar si estamos en la página de producto 
    const isProductPage = document.querySelector('.product');
    if(isProductPage){

        // obtenemos el color gracias al input del modelo, comprobamos si el input está relleno
        const modeloInput = document.querySelector('input[name="Modelo"]');
        if(modeloInput && modeloInput.value) {
            const data = fetch(`/collections/all?filter.p.m.custom.modelo_id=${modeloInput.value}&sections=colors-filter`).catch(err => console.log(err));
            data.then(res => res.json())
            .then(res => {
                const html = res['colors-filter'];
                const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.colors-filter').innerHTML;
                const colorInput = document.querySelector('input[name="Color"]');

                const wrapper = document.querySelector('.colores-picker');
                wrapper.innerHTML = section;
                
                const colorElements = wrapper.querySelectorAll('[data-color]');
                colorElements.forEach(el => {
                    if(el.dataset.color === colorInput.value) {
                        el.classList.add('activo');
                    }
                });
            })

        }

    }
});